<template>
    <div>
        <div v-if="modPhones.length <= 0" class="text-sm italic text-red-700">{{ $t('No phones assigned') }}</div>
        <div v-for="(phone, index) in modPhones" class="inline-flex w-full mt-1 relative rounded-md shadow-sm">
            <input
                :id="'phone_' + index + '_country'"
                v-model="phone.country"
                placeholder="ES"
                class="form-input block w-1/5 sm:w-16 py-1 bg-gray-200 border-r-0 rounded-l-sm rounded-r-none transition duration-150 ease-in-out text-center sm:text-sm sm:leading-5 focus:z-10"
                type="text"
                @input="setDirty(true)"
            >
            <input
                :id="'phone_' + index + '_country_code'"
                v-model="phone.country_code"
                placeholder="34"
                class="form-input block w-1/5 sm:w-16 py-1 bg-gray-200 rounded-none transition duration-150 ease-in-out text-center sm:text-sm sm:leading-5 focus:z-10"
                type="text"
                @input="setDirty(true)"
            >
            <input
                :id="'phone_' + index + '_number'" 
                v-model="phone.number"
                :placeholder="$t('Phone')"
                class="form-input block w-3/5 sm:w-full py-1 border-l-0 border-r-0 rounded-none transition duration-150 ease-in-out sm:text-sm sm:leading-5 focus:z-10"
                type="text"
                @input="setDirty(true)"
            >
            <button
                class="btn btn-red py-1 px-1 xl:px-2 shadow-sm rounded-l-none rounded-r-sm"
                type="button"
                @click="deletePhone(index)"
            >
                <svg-vue class="h-4 w-4 p-px text-red-800" icon="font-awesome.times-light"></svg-vue>
            </button>
        </div>
        <div class="mt-2">
            <button
                class="btn btn-secondary py-1 px-2 shadow-sm rounded-sm"
                type="button"
                @click="newPhone()"
            >
                <div class="flex gap-x-1">
                    <svg-vue class="h-4 w-4 text-green-300" icon="font-awesome.plus-solid"></svg-vue>
                    <div class="text-xs text-gray-300 leading-4">{{ $t('Add phone') }}</div>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "input-phone",
    props: {
        phoneList: {
            type: Array,
            required: true
        },
    },
    watch: {
        phoneList() {
            this.modPhones = [...this.phoneList];
            this.outPhones = [...this.phoneList];
        },
    },
    data() {
        return {
            phoneTemplate: {
                id: null,
                country: 'ES',
                country_code: '34',
                number: null
            },
            modPhones: [],
            outPhones: [],
            touched: false,
            dirty: false
        }
    },
    methods: {
        async savePhones() {
            const self = this;
            if (self.dirty) {
                let requests = [];
                self.outPhones = [];
                for (let i = 0; i < self.modPhones.length; i++) {
                    if (self.checkPhone(i)) {
                        requests.push(axios.post('api/dashboard/admin/phones', self.modPhones[i]).then(function (response) {
                            if (response.data.status != "error") self.outPhones.splice(i, 0, response.data.phone);
                        }).catch(() => {
                            //
                        }));
                    }
                }
                await Promise.all(requests);
                self.setDirty(false);
                return self.outPhones;
            }
            return self.modPhones;
        },
        newPhone() {
            this.modPhones.push({...this.phoneTemplate});
            this.setDirty(true);
        },
        deletePhone(index) {
            this.modPhones.splice(index, 1);
            this.setDirty(true);
        },
        checkPhone(index) {
            return this.modPhones[index].number && this.modPhones[index].country && this.modPhones[index].country_code;
        },
        setDirty(value) {
            this.dirty = value;
        },
        getPhoneIDs() {
            return this.outPhones.map(phone => phone.id);
        }
    }
}
</script>
